function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, ButtonGroup, Flex, Heading, Icon, IconButton, Image, Stack, Tag, Text, VStack } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import ContainerStack from './ContainerStack';
import dashboard from '@/assets/previews/dashboard.jpg';
import commands from '@/assets/previews/defaultCommands.jpg';
import songRequests from '@/assets/previews/songRequests.jpg';
import useIntlMemo from '@/hooks/useIntlMemo';
import PanelHoverWrapper from './PanelHoverWrapper';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import gridConnector from '@/assets/gridConnector.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
var CollageSection;
(function(CollageSection) {
    CollageSection[CollageSection["Dashboard"] = 0] = "Dashboard";
    CollageSection[CollageSection["Commands"] = 1] = "Commands";
    CollageSection[CollageSection["SongRequests"] = 2] = "SongRequests";
})(CollageSection || (CollageSection = {}));
var SECTION_ORDER = [
    0,
    1,
    2
];
function ScrollCollage(props) {
    var intl = useIntl();
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(0), 2), section = _React_useState[0], setSection = _React_useState[1];
    var nextSection = React.useCallback(function() {
        var nextIndex = (SECTION_ORDER.indexOf(section) + 1) % SECTION_ORDER.length;
        setSection(SECTION_ORDER[nextIndex]);
    }, [
        section
    ]);
    var prevSection = React.useCallback(function() {
        var nextIndex = (SECTION_ORDER.indexOf(section) - 1 + SECTION_ORDER.length) % SECTION_ORDER.length;
        setSection(SECTION_ORDER[nextIndex]);
    }, [
        section
    ]);
    var contentTitle = useIntlMemo(function(intl) {
        switch(section){
            case 0:
                return intl.formatMessage({
                    id: "hzSNj4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Dashboard"
                        }
                    ]
                });
            case 1:
                return intl.formatMessage({
                    id: "YCr+H+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Commands & Timers"
                        }
                    ]
                });
            case 2:
                return intl.formatMessage({
                    id: "3s3LJl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests"
                        }
                    ]
                });
            default:
                return null;
        }
    }, [
        section
    ]);
    var contentDescription = useIntlMemo(function(intl) {
        switch(section){
            case 0:
                return intl.formatMessage({
                    id: "cEqHwJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage Nightbot with ease and keep track of fun metrics in the dashboard."
                        }
                    ]
                });
            case 1:
                return intl.formatMessage({
                    id: "v1av8n",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Setup automated chat responses to viewers to keep them engaged and in the loop."
                        }
                    ]
                });
            case 2:
                return intl.formatMessage({
                    id: "1pvr5Q",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Keep viewers engaged and rewarded by letting them choose the music on stream."
                        }
                    ]
                });
            default:
                return null;
        }
    }, [
        section
    ]);
    function handleOnClick() {
        switch(section){
            case 0:
                navigate(WebRoutes.DASHBOARD);
                break;
            case 1:
                navigate(WebRoutes.COMMANDS);
                break;
            case 2:
                navigate(WebRoutes.SONG_REQUESTS);
                break;
            default:
                break;
        }
    }
    return /*#__PURE__*/ _jsx(Box, {
        backgroundColor: "backgroundPrimary",
        children: /*#__PURE__*/ _jsx(ContainerStack, _object_spread_props(_object_spread({
            backgroundImage: gridConnector,
            borderColor: "gray.750"
        }, props), {
            children: /*#__PURE__*/ _jsx(Box, {
                position: "relative",
                overflow: "hidden",
                height: "100vh",
                display: "grid",
                placeItems: "center",
                bgGradient: "radial(ellipse at center right, purpleAlpha.600, backgroundPrimary 75%)",
                children: /*#__PURE__*/ _jsxs(Flex, {
                    gap: 16,
                    paddingX: 8,
                    alignItems: "center",
                    flexDir: {
                        base: 'column',
                        md: 'row'
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Stack, {
                            width: "100%",
                            flex: 1,
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Tag, {
                                    colorScheme: "purple",
                                    size: "sm",
                                    borderRadius: "full",
                                    width: "fit-content",
                                    borderWidth: 1,
                                    paddingX: 4,
                                    cursor: "pointer",
                                    "aria-label": intl.formatMessage({
                                        id: "3S5YPS",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Try it now"
                                            }
                                        ]
                                    }),
                                    onClick: handleOnClick,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "3S5YPS",
                                        defaultMessage: "Try it now"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "xl",
                                    color: "textPrimary",
                                    children: contentTitle
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    fontSize: "lg",
                                    color: "textSecondary",
                                    children: contentDescription
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(VStack, {
                            gap: 4,
                            flex: 2,
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    borderRadius: "xl",
                                    borderWidth: "10px",
                                    borderColor: "purpleAlpha.400",
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ _jsx(PanelHoverWrapper, {
                                        onClick: handleOnClick,
                                        children: /*#__PURE__*/ _jsx(Box, {
                                            pos: "relative",
                                            width: "100%",
                                            borderRadius: "lg",
                                            overflow: "hidden",
                                            children: /*#__PURE__*/ _jsx(AnimatePresence, {
                                                mode: "popLayout",
                                                children: section === 2 ? /*#__PURE__*/ _jsx(Image, {
                                                    src: songRequests,
                                                    alt: intl.formatMessage({
                                                        id: "3s3LJl",
                                                        defaultMessage: [
                                                            {
                                                                type: 0,
                                                                value: "Song Requests"
                                                            }
                                                        ]
                                                    })
                                                }) : section === 1 ? /*#__PURE__*/ _jsx(Image, {
                                                    src: commands,
                                                    alt: intl.formatMessage({
                                                        id: "CokBda",
                                                        defaultMessage: [
                                                            {
                                                                type: 0,
                                                                value: "Custom Commands"
                                                            }
                                                        ]
                                                    })
                                                }) : section === 0 ? /*#__PURE__*/ _jsx(Image, {
                                                    src: dashboard,
                                                    alt: intl.formatMessage({
                                                        id: "hzSNj4",
                                                        defaultMessage: [
                                                            {
                                                                type: 0,
                                                                value: "Dashboard"
                                                            }
                                                        ]
                                                    })
                                                }) : null
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(ButtonGroup, {
                                    variant: "outline",
                                    size: "sm",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ _jsx(IconButton, {
                                            "aria-label": intl.formatMessage({
                                                id: "JJNc3c",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Previous"
                                                    }
                                                ]
                                            }),
                                            icon: /*#__PURE__*/ _jsx(Icon, {
                                                as: FontAwesomeIcon,
                                                icon: faArrowLeft
                                            }),
                                            onClick: prevSection
                                        }),
                                        /*#__PURE__*/ _jsx(IconButton, {
                                            "aria-label": intl.formatMessage({
                                                id: "9+Ddtu",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Next"
                                                    }
                                                ]
                                            }),
                                            icon: /*#__PURE__*/ _jsx(Icon, {
                                                as: FontAwesomeIcon,
                                                icon: faArrowRight
                                            }),
                                            onClick: nextSection
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        }))
    });
}
export default ScrollCollage;
